<template lang="pug">
div.padding.p-t-0
    report-filter(
        @onOutletChange="applyOutletFilter",
        @onDateChange="applyDateFilter"
    )
        template(slot="title") Stock Check
        template(slot="filters")
            div.col-md-3.m-y-sm.pull-right.filter
                select.form-control.c-select(
                    v-model="status"
                )
                    option(:value="null") Filter Status
                    option(value="0") In Progress
                    option(value="1") Completed

    div.row
        div.col-xs-12
            div.box
                v-server-table(
                    :url="api",
                    :name="tableName",
                    ref="datatable",
                    :columns="columns",
                    :options="options"
                )
</template>

<script>
import stockCheck from '@js/store/modules/stock-check';
import stockCheckEvent from './stock-check-event';

const exportUrl = 'stock_checks.exportData';

export default {
    data() {
        var that = this;

        return {
            status: null,
            tableName: 'VUETABLE_STOCK_CHECK',
            columns: [
                'reference_id',
                'outlet',
                'created_at',
                'completed_time',
                'counted_stocks',
                'status',
            ],
            options: {
                permission: {
                    create: () => this.permission.SAVE_STOCK_CHECK,
                    delete: () => this.permission.DELETE_STOCK_CHECK,
                },
                headings: {
                    created_at: 'Start Time',
                },
                checkbox: {
                    delete_title: 'Delete Stock Check',
                    api_delete: Laroute.route('stock_checks.delete'),
                },
                columnsClasses: {
                    counted_stocks: 'text-center',
                },
                customFilters: ['outlet_id', 'since', 'until', 'status'],
                initFilters: {
                    outlet_id: this.$store.getters.activeOutlet,
                },
                orderBy: {
                    column: 'created_at',
                    ascending: false,
                },
                create_btn: {
                    title: 'New Stock Check',
                    action: () => {
                        this.$router.push('/create');
                    },
                },
                rowClassCallback: row => 'pointer',
                rowClickCallback: that.showEditForm,
                checkboxDisableCallback(row) {
                    return row.status === 1;
                },
                csv_url: Laroute.route(exportUrl, { type: 'csv' }),
                pdf_url: Laroute.route(exportUrl, { type: 'pdf' }),
                xls_url: Laroute.route(exportUrl, { type: 'XLSX' }),
                templates: {
                    status(h, row) {
                        return require('./stock-check-list-status.jsx')(h, row);
                    },
                    created_at(h, row) {
                        return that.formattedDate(row.created_at);
                    },
                    completed_time(h, row) {
                        if (row.status == 1) {
                            return that.formattedDate(row.completed_time);
                        }
                    },
                },
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('stock_checks.index');
        },
    },

    watch: {
        status(newValue) {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'status',
                value: newValue,
            });
        },
    },

    created() {
        stockCheckEvent.$on('stock-check-saved', () => {
            this.$refs.datatable.getData();
        });
    },

    methods: {
        showEditForm(row) {
            this.$router.push(`/${row.id}`);
        },

        applyOutletFilter(outlet) {
            this.$refs.datatable.applyOutletFilter(outlet);
        },

        applyDateFilter(date) {
            this.$refs.datatable.applyDateFilter(date);
            stockCheckEvent.$emit('applyDateFilter', date);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_check/stock-check-list.vue